<template>
  <div>
    <div class="ui ordered fluid vertical steps">
      <a
        class="step"
        v-for="(interaction, iindex) in instance.ngn_interactions"
        v-bind:class="{ completed: interaction.finished_date }"
        :key="iindex"
      >
        <div class="content">
          <div v-if="interaction.component.name" class="title">
            {{ interaction.component.name }}
            <small>[{{ interaction.component.type }}]</small>
          </div>
          <div v-else class="title">
            {{ interaction.component.type }}
          </div>
          <div class="description" v-if="interaction.finished_date">
            {{ $t("finished") }}
            {{
              interaction.finished_date
                | formatDate(enterprise_setup.detailed_date_format)
            }}
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { enterprise_setup } from "@/utils.js";
import filters from "@/filters.js";

export default {
  name: "RobocreditInstanceModalFlow",
  filters: filters,
  props: {
    instance: Object,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {};
  },
};
</script>
